export const socialsData = {
    github: 'https://github.com/sachidanand-pradhan',
    linkedIn: 'https://www.linkedin.com/in/sachidanand-pradhan-885147170/',
    codepen: 'https://codepen.io/sachidanand-pradhan/pens/public',
    reddit: 'https://www.reddit.com/user/coderSachida44',
    stackOverflow: 'https://stackoverflow.com/users/17838808/sachidanand-pradhan',
}